import {
    SYSTEM_CHOOSE_CURRENT_INDUSTRYTYPE,
} from './constants';
  
export function chooseCurrentIndustryType(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_INDUSTRYTYPE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_INDUSTRYTYPE:
        return {
          ...state,
          currentIndustryType:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentIndustryType.js